<template>
<div id="billing">
  <div class="row" v-if="nothingToShow !=''">
  <div class="col text-center">
  <h3>{{nothingToShow}}</h3>
  </div>
  </div>
  <div class="container fluid" v-else-if="isLoaded && user.authenticated">
    <div class="row">
      <div class="col-md-12">
        <p><span>Bank Name:</span> {{billinginfo.accountName}}</p>
        <p><span>Account Type:</span> {{billinginfo.accountType}}</p>
        <p><span>Account Number:</span> {{billinginfo.accountNum}}</p>
        <p><span>Routing Number:</span> {{billinginfo.routingNum}}</p>
        <p><span>ACH Active: </span><span v-if="billinginfo.isACHActive" class="text-success">Yes</span><span v-else class="text-danger">No</span></p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <b-btn class="btn btn-primary" v-b-modal="modalCC(parentData)">CC Auth Form</b-btn>
      </div>
      <div class="col-md-3">
        <b-btn class="btn btn-primary" v-b-modal="modalACH(parentData)">ACH Change Form</b-btn>
      </div>
    </div>
  </div>
  <div class="container fluid" v-else>
    <div class="row" >
      <div class="col text-center">
        <h3>Sorry it looks like you've been logged out, please <router-link to="/login">Login</router-link> to resume</h3>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios'
import auth from './auth'
export default {
  name: 'modalBilling',
  components: {
  },
  props: {
    parentData: {
      type: Number
    }
  },
  data: function () {
    return {
      billinginfo: null,
      user: auth.user,
      nothingToShow: 'There is no information to display at this time',
      apiUrl: localStorage.getItem('apiURL')
    }
  },
  methods: {
    modalACH (key) {
      return 'modalACH' + key
    },
    modalCC (key) {
      return 'modalCC' + key
    }
  },
  mounted: function () {
    axios
      .get(this.apiUrl + auth.user.clientID + '/contracts/' + this.parentData + '/billingaccounts', {
        headers: auth.getAuthHeader()
      })
      .then(response => {
        this.billinginfo = response.data
        this.nothingToShow = ''
      })
  },
  computed: {
    isLoaded: function () {
      if (this.hasOwnProperty('billinginfo') &&
      this.billinginfo != null) {
        return true
      }
      return false
    }
  }
}
</script>

<style>
#billing span {
  font-weight:bold;
}
</style>



// WEBPACK FOOTER //
// src/modalBilling.vue